import { useEffect, useMemo, useState } from "react";

export const useCountdown = (remainingSeconds?: number | null) => {
  const deadline = useMemo(
    () => (remainingSeconds == null ? null : Date.now() + Math.max(0, remainingSeconds) * 1000),
    [remainingSeconds]
  );

  const getRemaining = () =>
    deadline == null ? 0 : Math.max(0, Math.round((deadline - Date.now()) / 1000));

  const [remaining, setRemaining] = useState(getRemaining);

  useEffect(() => {
    setRemaining(getRemaining());
    if (deadline == null) return;

    const timer = setInterval(() => setRemaining(getRemaining()), 1000);
    return () => clearInterval(timer);
  }, [deadline]);

  return remaining;
};

export const formatCountdown = (seconds: number) => {
  const h = Math.floor(seconds / 3600);
  const m = Math.floor((seconds % 3600) / 60);
  const s = seconds % 60;
  const pad = (n: number) => String(n).padStart(2, "0");

  return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${pad(m)}:${pad(s)}`;
};
